module.exports = EchoUtils = {
    private( channel, event, callback) {
        window.Echo.private(channel).listen(event, callback);
    },
    public( channel, event, callback) {
        window.Echo.channel(channel).listen(event, callback);
    },
}
